import {
  Control,
  Controller,
  FieldErrors,
  UseFormSetValue,
  useWatch,
} from 'react-hook-form';
import { CreateProductFormSchemaType } from '../common';
import i18n from 'i18n';
import LOCALS from 'commons/locals';
import { Select } from 'antd';
import { useEffect } from 'react';
import { STOCK_PLACE_MAP } from 'constant/stock-place';
import { ProductTaxRegime } from 'constants/france-tax';

/** 内嵌在库存地半格内，与价格的「税抜き価格」同布局模式 */
const ProductTaxRegimeField = ({
  control,
  errors,
  setValue,
}: {
  control: Control<CreateProductFormSchemaType>;
  errors: FieldErrors<CreateProductFormSchemaType>;
  setValue: UseFormSetValue<CreateProductFormSchemaType>;
}) => {
  const stockPlace = useWatch({ control, name: 'stockPlace' });
  const taxRegime = useWatch({ control, name: 'taxRegime' });
  const isFranceStock = stockPlace === STOCK_PLACE_MAP.FRANCE;

  useEffect(() => {
    if (isFranceStock) {
      if (!taxRegime) {
        setValue('taxRegime', ProductTaxRegime.STANDARD_TVA);
      }
      return;
    }

    if (taxRegime) {
      setValue('taxRegime', null);
    }
  }, [isFranceStock, setValue, taxRegime]);

  if (!isFranceStock) {
    return null;
  }

  return (
    <div className="flex items-center gap-2 w-full">
      <label className="required-field shrink-0 whitespace-nowrap">
        {i18n.t(LOCALS.product_tax_regime)}:
      </label>
      <Controller
        name="taxRegime"
        control={control}
        render={({ field }) => (
          <div className="relative w-full">
            <Select
              status={errors.taxRegime ? 'error' : undefined}
              value={field.value ?? undefined}
              onChange={field.onChange}
              className="w-full"
              options={[
                {
                  value: ProductTaxRegime.STANDARD_TVA,
                  label: i18n.t(LOCALS.product_tax_regime_standard_tva),
                },
                {
                  value: ProductTaxRegime.MARGIN,
                  label: i18n.t(LOCALS.product_tax_regime_margin),
                },
              ]}
              placeholder={i18n.t(LOCALS.please_select)}
            />
            {errors.taxRegime && (
              <p style={{ color: 'red' }} className="absolute left-0">
                {i18n.t(LOCALS.required_field)}
              </p>
            )}
          </div>
        )}
      />
    </div>
  );
};

export default ProductTaxRegimeField;
